<fuse-widget class="widget p-0 h-100-p" fxLayout="column">
  <!-- Front -->
  <div
    class="fuse-widget-front mat-white-bg mat-elevation-z2"
    fxLayout="column"
    fxLayoutAlign="stretch stretch"
  >
    <mat-toolbar
      class="px-16 py-12 border-bottom mat-accent-bg title-bar"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="h3 title pr-4" style="display: flex">
          Notes
          <div *ngIf="!isLoading">&nbsp;({{ numberofNotes }})</div>
        </div>
      </div>
      <div class="actions" fxLayout="row" fxLayoutAlign="start center">
        <mat-divider class="style-fix" [vertical]="true"></mat-divider>

        <span *ngIf="!noteOrderAscending" class="h4">Newest to Oldest</span>
        <span *ngIf="noteOrderAscending" class="h4">Oldest to Newest</span>
        <button [matMenuTriggerFor]="noteOrderMenu" aria-label="Note Order">
          <mat-icon class="mat-accent-bg">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #noteOrderMenu="matMenu">
          <button
            mat-menu-item
            (click)="setNoteOrder(false)"
            title="Newest to Oldest"
          >
            Newest to Oldest
          </button>
          <button
            mat-menu-item
            (click)="setNoteOrder(true)"
            title="Oldest to Newest"
          >
            Oldest to Newest
          </button>
        </mat-menu>

        <mat-divider
          *ngIf="showNoteTypeFilter"
          class="style-fix"
          [vertical]="true"
        ></mat-divider>

        <button
          *ngIf="showNoteTypeFilter"
          mat-icon-button
          class="mat-icon-button"
          [matMenuTriggerFor]="mnuNoteTypeFilter"
          #noteTypeFilter
          aria-label="Note Type Filter"
          matTooltip="Note Type Filter"
        >
          <mat-icon class="mat-accent-bg">filter_list</mat-icon>
        </button>
        <mat-menu #mnuNoteTypeFilter="matMenu">
          <button
            mat-menu-item
            *ngFor="let filter of this.noteTypes"
            (click)="applyNoteTypeFilter(filter)"
          >
            <mat-icon
              [ngStyle]="!filter.selected ? { color: 'transparent' } : {}"
              >done</mat-icon
            >
            {{ filter.name }}
          </button>
        </mat-menu>

        <mat-divider class="style-fix" [vertical]="true"></mat-divider>

        <button
          mat-icon-button
          class="mat-icon-button"
          *ngIf="!displayPage"
          (click)="displayAsPage(true)"
          aria-label="Display as page"
          matTooltip="Display as Page"
        >
          <mat-icon class="mat-accent-bg">description</mat-icon>
        </button>

        <button
          mat-icon-button
          class="mat-icon-button"
          *ngIf="displayPage"
          (click)="displayAsPage(false)"
          aria-label="Display as list"
          matTooltip="Display as List"
        >
          <mat-icon class="mat-accent-bg">list</mat-icon>
        </button>

        <mat-divider class="style-fix" [vertical]="true"></mat-divider>

        <button
          mat-icon-button
          class="mat-icon-button"
          (click)="openNoteManager($event)"
          aria-label="Open note manager"
          matTooltip="Open Note Manager"
        >
          <mat-icon class="mat-accent-bg">launch</mat-icon>
        </button>

        <mat-divider
          *ngIf="allowEdit"
          class="style-fix"
          [vertical]="true"
        ></mat-divider>
        <button
          *ngIf="allowEdit"
          mat-icon-button
          class="mat-icon-button"
          aria-label="Add Note"
          [disabled]="!allowEdit"
          fxFlex
          #addButton
          (click)="addButton._elementRef.nativeElement.blur(); add()"
          matTooltip="Add Note"
        >
          <mat-icon class="mat-accent-bg">add</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <div *ngIf="isLoading"><app-loading></app-loading></div>

    <div class="notelist" fxLayout="row" *ngIf="!displayPage && !isLoading">
      <note-list
        fxFlex
        inWidget="true"
        [parent]="parent"
        [readOnly]="userReadOnly"
      ></note-list>
    </div>

    <div class="notelist" fxLayout="row" *ngIf="displayPage">
      <note-page
        fxFlex
        inWidget="true"
        [parent]="parent"
        [readOnly]="userReadOnly"
      ></note-page>
    </div>
  </div>
  <!-- / Front -->
</fuse-widget>
